export default __webpack_public_path__ + "static/media/playIconFull.f381977b.svg";